<template>
  <div class="content">
    <div class="el-row">
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">公司名称：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.companyName}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">银行卡号：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.cardNumber}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">开户行：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.openBank}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">  
        <div class="el-form-item el-form-item--medium"> 
          <label class="el-form-item__label" style="width: 120px;">审核状态：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.auditStatus}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">营业执照正面：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">
            <viewer :images="signImages1">
              <img  class="reg-img"  v-for="(src,index) in signImages1" :src="src" :key="index"/>
            </viewer>
          </div>
        </div>
      </div>
    </div>
    <div class="left" style="padding-left:120px;padding-bottom: 30px;padding-top:100px;">
      <el-button type="primary" size="medium" @click="boot()">审核通过</el-button>
      <el-button type="primary" size="medium" @click="turnoff()" class="el-button--danger">审核不通过</el-button>
    </div>
  </div>
</template>

<script>
import { bankdetail ,updateStatus} from "@/api/api.js";
export default {
  data() {
    return {
      data: {},
      url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API +'/upload/image/',
      input: '',
      signImages1: [],
      id:this.$route.query.id
    };
  },
  computed: {},
  methods: {
    transferOrderType(status) {
      let obj = {
        0: "未通过 ",
        1: "待审核",
        2: "已通过",
      };
      return obj[status];
    },
    // 获取列表
    initData() {
      bankdetail({id:this.id}).then(res => {
        if (res.data.code == 200) {
          this.data = res.data.data;
          this.data.auditStatus = this.transferOrderType(res.data.data.auditStatus);
          this.signImages1.push(res.data.data.imgUrl)
        }
      })
    },
    // 审核通过
    boot() {
      let params = {
        id:this.id,
        status:'2'
      };
      updateStatus(params).then(res =>{
        if (res.data.code == 200) {
          this.$message({
            message: '审核通过',
            type: 'success'
          });
          this.$router.push("bankList");
        }
      })
    },
    // 审核不通过
    turnoff() {
      let params = {
        id:this.id,
        status:'0',
      };
      updateStatus(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.error('审核不通过');
          this.$router.push("bankList");
        }
      })
    },
  },
  created() {
    this.initData();
  },
  mounted() {}
};
</script>
<style scoped>
.reg-img{
  max-width: 300px;
  max-height: 300px;
}
.el-form-item__content{
  color: #1890ff;
}
</style>
